import { modifiers } from '../styles.js'
import { scrollTo } from './scrollTo.js'
import rendered from '@mailobj-browser/front/js/tree/rendered.js'

export const scrollToEndY = (container) => {
  const { scrollHeight } = container

  if (container.classList.contains(modifiers.scroll_to.end_y)) {
    scrollTo(container, { top: scrollHeight })
  }
}

export const scrollToEndX = (container) => {
  const { ownerDocument } = container
  const { dir } = ownerDocument
  const { scrollWidth } = container
  const scrollX = dir === 'ltr' ? scrollWidth : -scrollWidth

  if (container.classList.contains(modifiers.scroll_to.end_x)) {
    scrollTo(container, { left: scrollX })
  }
}

export default container => {
  queueMicrotask(async () => {
    const { ownerDocument } = container
    const { body } = ownerDocument

    await rendered(container, body)

    scrollToEndY(container)
    scrollToEndX(container)
  })
}